import styled from "styled-components";
import { ReactComponent as Swoosh1 } from "./assets/sharp-swoosh.svg";
import { ReactComponent as Swoosh2 } from "./assets/sharp-swoosh2.svg";
import Slider from "react-slick";

export const Container = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  background-color: #1f2d3d;
  justify-content: center;
`;

export const GradientTop = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: -1px;
  height: 300px;
  background: linear-gradient(183deg, #1f2d3d 2.9%, rgba(31, 45, 61, 0) 21.41%);
`;

export const GradientBottom = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0px;
  height: 100px;
  background: linear-gradient(1deg, #1f2d3d 1.75%, rgba(31, 45, 61, 0) 45.39%);
  z-index: 999;
`;

export const SectionGradient = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0px;
  background: linear-gradient(6deg, #1f2d3d 38.75%, rgba(31, 45, 61, 0) 56.39%);
  z-index: 99;
`;

export const TopSwoosh = styled(Swoosh1)``;

export const BottomSwoosh = styled(Swoosh2)`
  position: absolute;
  bottom: 2px;
  right: 0;
`;

export const Carousel = styled(Slider)`
  height: 316px;
  background-color: transparent;
  top: -26vh;

  @media screen and (max-width: 769px) {
    top: -125px;
  }

  @media only screen and (min-height: 769px) {
    top: -16vh;
  }

  @media only screen and (min-height: 846px) {
    top: -2vh;
  }
`;

export const PhotosSection = styled.div`
  width: 100%;
  height: 316px;

  img {
    object-fit: contain;
    width: 100% !important;
  }

  @media only screen and (min-width: 769px) {
    height: 632px;

    img {
      object-fit: contain;
      width: 100% !important;
      height: 680px !important;
    }
  }
`;

export const DescriptionSection = styled.div`
  position: relative;
  width: 100%;
  padding: 0 24px;
  z-index: 1;
  text-align: center;
  top: -35px;

  @media only screen and (max-height: 667px) {
    top: -40px;
  }

  @media only screen and (min-width: 769px) {
    top: -0vh;
  }

  @media only screen and (min-height: 769px) {
    top: 8vh;
  }

  @media only screen and (min-height: 846px) {
    top: 200px;
  }
`;

export const DescriptionTitle = styled.p`
  font-size: 20px;
  color: white;
  font-weight: bold;
  line-height: 29px;
  letter-spacing: 0.091px;
  margin-bottom: 16px;

  @media only screen and (min-width: 769px) {
    font-size: 28px;
  }
`;

export const DescriptionText = styled.p`
  font-family: Gilroy;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  color: white;

  @media only screen and (min-width: 769px) {
    font-size: 18px;
  }
`;

export const DotsWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  top: -4px;
  width: 100%;
  height: 10px;
  column-gap: 4px;
`;

export const Dots = styled.div`
  width: ${(props) => (props?.isActive ? "16px" : "8px")};
  height: 8px;
  border-radius: 8px;
  background-color: white;
`;
